/**
 * 运行时环境（由 Vite 注入）。业务代码请从此处读取，避免直接使用 import.meta.env 散落各处。
 */
export const env = {
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  appTitle: import.meta.env.VITE_APP_TITLE ?? 'minego-website',
  oauthPortalUrl: import.meta.env.VITE_OAUTH_PORTAL_URL,
  oauthAppId: import.meta.env.VITE_APP_ID,
} as const
